import { render, staticRenderFns } from "./ReturnBuilding.vue?vue&type=template&id=1639b41e&"
import script from "./ReturnBuilding.vue?vue&type=script&lang=js&"
export * from "./ReturnBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports